var NavigationComponent = /** @class */ (function () {
    function NavigationComponent(args) {
        var _a;
        console.log(args);
        this.composer = (_a = args === null || args === void 0 ? void 0 : args.composer) !== null && _a !== void 0 ? _a : {};
    }
    Object.defineProperty(NavigationComponent.prototype, "color", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this === null || this === void 0 ? void 0 : this.composer) === null || _a === void 0 ? void 0 : _a.color) !== null && _b !== void 0 ? _b : '#fff';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NavigationComponent.prototype, "bgColor", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this === null || this === void 0 ? void 0 : this.composer) === null || _a === void 0 ? void 0 : _a.bgColor) !== null && _b !== void 0 ? _b : '#212529';
        },
        enumerable: false,
        configurable: true
    });
    //If using a completely unique template e.g. for CEF , the outermost div is still rendered both cases i.e. <nav></nav> and <footer></footer>. But the innerHTML will be defined from within the CEF project and passed in.
    NavigationComponent.prototype.composeTemplate = function () {
        var _a, _b;
        if (!((_a = this === null || this === void 0 ? void 0 : this.composer) === null || _a === void 0 ? void 0 : _a.template))
            return '';
        var template = (_b = this === null || this === void 0 ? void 0 : this.composer) === null || _b === void 0 ? void 0 : _b.template;
        if (typeof template === "string" || template instanceof HTMLElement) {
            return template;
        }
        else {
            return template();
        }
    };
    //Default ll template
    NavigationComponent.prototype.composeDefault = function () { };
    NavigationComponent.prototype.render = function () { };
    return NavigationComponent;
}());
export { NavigationComponent };
